module.exports = __webpack_public_path__ + "img/finish_teknisyen_kirec_pie_chart.d779c2b0.jpg";